export function init () {
  const root = document.querySelector('.rodo-confirmation')
  if (!root) return false
  
  /**
   * There's need to add this class because of lack of some
   * padding between other containers.
   */
  return root.closest('.container').classList.add('rodo-confirmation-container')
}


// WEBPACK FOOTER //
// ./src/modules/rodoConfirmation.js